import ProductDetailsPage from "./product-details.page"
export default ProductDetailsPage;
